import {
  Box,
  TextField,
  FormHelperText,
  CircularProgress,
  Button,
} from "@material-ui/core";
import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { CheckSquare, XCircle } from "react-feather";
import axios from "axios";
import Notify from "src/notification/Notify";

const token = localStorage.getItem("token");
const user_id = localStorage.getItem("user_id");
const username = localStorage.getItem("username");

const Password = ({ detailsRd, details, getProfileInformation }) => {
  const convertFormdata = (object) => {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  };

  return (
    <Box>
      {detailsRd ? (
        Object.keys(details).length > 0 ? (
          <Formik
            initialValues={{
              user_id: user_id,
              token: token,
              username: username,
              new_password: "",
              new_password_confirm: "",
              password: "",
            }}
            validationSchema={Yup.object().shape({
              new_password: Yup.string()
                .min(5)
                .required("New password is required"),
              new_password_confirm: Yup.string()
                .oneOf(
                  [Yup.ref("new_password"), null],
                  "New password must match"
                )
                .required("New password confirm is required"),
              password: Yup.string().required(),
            })}
            onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
              setSubmitting(true);
              axios
                .post(
                  "encoder/profile/update-password",
                  convertFormdata(values)
                )
                .then((response) => {
                  const data = response.data;

                  if (data.message === "success") {
                    resetForm();
                    Notify.successRequest("password updated");
                    getProfileInformation();
                  }
                })
                .catch((error) =>
                  console.log("request has error:", error.message)
                )
                .finally(() => setSubmitting(false));
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              resetForm,
              isSubmitting,
              touched,
              values,
              setFieldValue,
            }) => (
              <form noValidate onSubmit={handleSubmit}>
                <Box mb={2}>
                  <TextField
                    error={Boolean(touched.new_password && errors.new_password)}
                    helperText={touched.new_password && errors.new_password}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.new_password}
                    fullWidth
                    required
                    name="new_password"
                    label="New Password"
                    variant="outlined"
                    type="password"
                  />
                </Box>

                <Box my={2}>
                  <TextField
                    error={Boolean(
                      touched.new_password_confirm &&
                        errors.new_password_confirm
                    )}
                    helperText={
                      touched.new_password_confirm &&
                      errors.new_password_confirm
                    }
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.new_password_confirm}
                    fullWidth
                    required
                    name="new_password_confirm"
                    label="New Password Confirm"
                    variant="outlined"
                    type="password"
                  />
                </Box>

                <Box my={2}>
                  <TextField
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    fullWidth
                    name="password"
                    label="Current Password"
                    variant="outlined"
                    type="password"
                  />
                </Box>

                {errors.submit && (
                  <Box mt={3}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Box>
                )}

                <Box display="flex">
                  <Box mr={2}>
                    <Button
                      size="large"
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={
                        isSubmitting ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          <CheckSquare />
                        )
                      }
                      disabled={isSubmitting}
                    >
                      Save
                    </Button>
                  </Box>

                  <Button
                    size="large"
                    variant="contained"
                    color="default"
                    onClick={resetForm}
                    startIcon={<XCircle />}
                  >
                    Clear
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        ) : (
          Notify.noRecord()
        )
      ) : (
        Notify.loading()
      )}
    </Box>
  );
};

export default Password;
